import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const INVEST_SUMMARY = "/login"
export const ALL_INVESTMENTS = "/register"
export const URL_GET_INVESTMENT_CALCULATION = MOBILE_BASE_URL + "/wallet/calculation"